// src/utils/analysisConfig.js

import {
    fetchDataCosechaMecanica,
    shouldEnableExecBashCosechaMecanica,
    cargaDatosCosechaMecanica,
    fetchDataCosechaMecanicaIndicators,
    initialIndicatorsCosechaMecanica
} from "../analysis/cosechaMecanica/cosechaMecanicaFetchData";

import {
    fetchDataAps,
    shouldEnableExecBashAps,
    cargaDatosAps,
    fetchDataApsIndicators,
    initialIndicatorsAps
} from "../analysis/aps/apsFetchData";

import {
    fetchDataHerbicidas,
    shouldEnableExecBashHerbicidas,
    cargaDatosHerbicidas,
    initialIndicatorsHerbicidas
} from "../analysis/herbicidas/herbicidasFetchData";

import {
    fetchDataFertilizacion,
    shouldEnableExecBashFertilizacion,
    cargaDatosFertilizacion, fetchDataFertilizacionIndicators
} from "../analysis/fertilizacion/fertilizacionFetchData";

import {
    fetchDataConteoPalma,
    shouldEnableExecBashConteoPalmas
} from "../analysis/conteoPalmas/conteoPalmasFetch";

import {
    fetchDataConteoAgave,
    shouldEnableExecBashConteoAgaves,
    mappingConfig
} from "../analysis/conteoAgave/conteoAgaveFetch";

import {
    fetchDataDeteccionMaleza,
    shouldEnableExecBashDeteccionMaleza
} from "../analysis/deteccionMaleza/deteccionMalezaFetch";

import {
    fetchDataDeteccionMalezaIndicators,
    initialIndicatorsDeteccionMaleza
} from "../analysis/deteccionMaleza/deteccionMalezaFetchIndicators";

import {
    shouldEnableExecBashPlanificacionCosecha
} from "../analysis/planificacionCosechaProcess/planificacionCosechaProcess";

import {
shouldEnableExecBashPlanificacionHerbicidas
} from "../analysis/PlanificacionHerbicidasProcess/PlanificacionHerbicidasProcess";

const analysisConfig = {
    APLICACIONES_AEREAS: {
        id: 1,
        fetchData: fetchDataAps,
        fetchDataIndicators: fetchDataApsIndicators,
        cargaDatos: cargaDatosAps,
        shouldEnableExecBash: shouldEnableExecBashAps,
        initialIndicators: initialIndicatorsAps,
    },
    COSECHA_MECANICA: {
        id: 2,
        fetchData: fetchDataCosechaMecanica,
        fetchDataIndicators: fetchDataCosechaMecanicaIndicators,
        cargaDatos: cargaDatosCosechaMecanica,
        shouldEnableExecBash: shouldEnableExecBashCosechaMecanica,
        templatePath: "/templates/COSECHA_MECANICA.csv",
        initialIndicators: initialIndicatorsCosechaMecanica,
    },
    FERTILIZACION: {
        id: 4,
        fetchData: fetchDataFertilizacion,
        fetchDataIndicators: fetchDataFertilizacionIndicators,
        cargaDatos: cargaDatosFertilizacion,
        shouldEnableExecBash: shouldEnableExecBashFertilizacion,
        templatePath: "/templates/FERTILIZACION.csv",
    },
    HERBICIDAS: {
        id: 3,
        fetchData: fetchDataHerbicidas,
        cargaDatos: cargaDatosHerbicidas,
        shouldEnableExecBash: shouldEnableExecBashHerbicidas,
        initialIndicators: initialIndicatorsHerbicidas,
        // Herbicidas ya no usa plantilla CSV: datos manuales + KML/ZIP de franjas.
    },
    CONTEO_PALMA: {
        id: 5,
        shouldEnableExecBash: shouldEnableExecBashConteoPalmas,
        fetchData: fetchDataConteoPalma,
    },
    CONTEO_AGAVE: {
        id: 9,
        shouldEnableExecBash: shouldEnableExecBashConteoAgaves,
        fetchData: fetchDataConteoAgave,
        mappingConfig: mappingConfig
    },
    DETECCION_MALEZA: {
        id: 7,
        shouldEnableExecBash: shouldEnableExecBashDeteccionMaleza,
        fetchData: fetchDataDeteccionMaleza,
        fetchDataIndicators: fetchDataDeteccionMalezaIndicators,
        initialIndicators: initialIndicatorsDeteccionMaleza,
    },
    PLANIFICACION_DE_COSECHA: {
        id: 6,
        shouldEnableExecBash: shouldEnableExecBashPlanificacionCosecha,
        templatePath: "/templates/PLANIFICACION_DE_COSECHA.csv",
    },
    PLANIFICACION_DE_HERBICIDAS: {
        id: 8,
        shouldEnableExecBash: shouldEnableExecBashPlanificacionHerbicidas,
        templatePath: "/templates/PLANIFICACION_DE_HERBICIDAS.csv",
    },
};

export default analysisConfig;
